export const TUTO_DATA = [
  {
    id: "1",
    test_completed: false,
    timer: 60,
    data: {
      tokens: [
        {
          name: "c1h1",
          type: "Abstract",
          x: 372,
          y: 457,
        },
        {
          name: "c1s1",
          type: "Abstract",
          x: 112,
          y: 585,
        },
        {
          name: "c1",
          type: "Abstract",
          x: -354,
          y: 585,
        },
        {
          name: "c1b1",
          type: "Abstract",
          x: -116,
          y: 410,
        },
      ],
      figures: [
        {
          name: "c1h1",
          parent: "Simple",
          type: "Abstract",
          x: 113,
          y: -103,
        },
        {
          name: "c1h1",
          parent: "Simple",
          type: "Abstract",
          x: 313,
          y: -103,
        },
      ],
      dropzones: [
        {
          name: "DropZone1",
          parent: "Simple",
          x: 513,
          y: -103,
        },
      ],
      masks: [
        {
          name: "Simple",
          type: "Simple",
          height: 206,
          width: 626,
          rotation: 0,
          fill: 0,
          x: 0,
          y: 108,
        },
      ],
      answer: [
        {
          token: "c1h1",
          dropzone: "DropZone1",
        },
      ],
    },
  },
  {
    id: 1,
    test_completed: false,
    timer: 60,
    data: {
      tokens: [
        {
          name: "1",
          type: "Numeric",
          x: -288,
          y: -196,
        },
        {
          name: "9c1",
          type: "Numeric",
          x: 377,
          y: -266,
        },
        {
          name: "3",
          type: "Numeric",
          x: 29,
          y: -348,
        },
      ],
      figures: [
        {
          name: "c1h1",
          parent: "Simple",
          type: "Abstract",
          x: 313,
          y: -110,
        },
        {
          name: "c1h1",
          parent: "Simple",
          type: "Abstract",
          x: 122,
          y: -110,
        },
        {
          name: "c1h1",
          parent: "Simple (1)",
          type: "Abstract",
          x: 313,
          y: -110,
        },
        {
          name: "c1b1",
          parent: "Simple (1)",
          type: "Abstract",
          x: 116,
          y: -110,
        },
        {
          name: "c1b1",
          parent: "Simple (2)",
          type: "Abstract",
          x: 313,
          y: -110,
        },
        {
          name: "c1b1",
          parent: "Simple (2)",
          type: "Abstract",
          x: 116,
          y: -110,
        },
        {
          name: "2c1",
          parent: "Simple",
          type: "Numeric",
          x: 512,
          y: -110,
        },
        {
          name: "6c1",
          parent: "Simple (1)",
          type: "Numeric",
          x: 512,
          y: -110,
        },
      ],
      dropzones: [
        {
          name: "DropZone1",
          parent: "Simple (2)",
          x: 516,
          y: -110,
        },
      ],
      masks: [
        {
          name: "Simple",
          type: "Simple",
          height: 220,
          width: 627,
          rotation: 0,
          fill: 0,
          x: 0,
          y: 580,
        },
        {
          name: "Simple (1)",
          type: "Simple",
          height: 220,
          width: 627,
          rotation: 0,
          fill: 0,
          x: 0,
          y: 340,
        },
        {
          name: "Simple (2)",
          type: "Simple",
          height: 220,
          width: 627,
          rotation: 0,
          fill: 0,
          x: 0,
          y: 100,
        },
      ],
      answer: [
        {
          token: "1",
          dropzone: "DropZone1",
        },
        {
          token: "9c1",
          dropzone: "DropZone1",
        },
      ],
    },
  },
  {
    id: "1",
    test_completed: false,
    timer: 60,
    data: {
      tokens: [
        {
          name: "c1",
          type: "Abstract",
          x: -358,
          y: 576,
        },
        {
          name: "c1s1",
          type: "Abstract",
          x: 0,
          y: 634,
        },
        {
          name: "c2h1",
          type: "Abstract",
          x: 344,
          y: 576,
        },
      ],
      figures: [
        {
          name: "c2s1",
          parent: "Simple",
          type: "Abstract",
          x: 113,
          y: -103,
        },
        {
          name: "c2s1",
          parent: "Simple",
          type: "Abstract",
          x: 513,
          y: -103,
        },
        {
          name: "c1",
          parent: "Simple2",
          type: "Abstract",
          x: 513,
          y: -103,
        },
        {
          name: "c1",
          parent: "Simple2",
          type: "Abstract",
          x: 113,
          y: -103,
        },
        {
          name: "c1",
          parent: "Simple2",
          type: "Abstract",
          x: 313,
          y: -103,
        },
      ],
      dropzones: [
        {
          name: "DropZone1",
          parent: "Simple",
          x: 313,
          y: -103,
        },
      ],
      masks: [
        {
          name: "Simple",
          type: "Simple",
          height: 206,
          width: 626,
          rotation: 0,
          fill: 0,
          x: 0,
          y: 300,
        },
        {
          name: "Simple2",
          type: "Simple",
          height: 206,
          width: 626,
          rotation: 0,
          fill: 0,
          x: 0,
          y: 60,
        },
      ],
      answer: [
        {
          token: "c1s1",
          dropzone: "DropZone1",
        },
        {
          token: "c1",
          dropzone: "DropZone1",
        },
      ],
    },
  },
  {
    id: "1",
    test_completed: false,
    timer: 60,
    data: {
      tokens: [
        {
          name: "5c1",
          type: "Numeric",
          x: -311,
          y: 630,
        },
        {
          name: "0c1",
          type: "Numeric",
          x: 391.000153,
          y: 630,
        },
        {
          name: "4c2",
          type: "Numeric",
          x: 142,
          y: 524,
        },
        {
          name: "-1c1",
          type: "Numeric",
          x: -136,
          y: 455,
        },
      ],
      figures: [
        {
          name: "1c1",
          parent: "Simple",
          type: "Numeric",
          x: 110,
          y: -111,
        },
        {
          name: "2c1",
          parent: "Simple",
          type: "Numeric",
          x: 310,
          y: -111,
        },
        {
          name: "4c1",
          parent: "Simple",
          type: "Numeric",
          x: 710,
          y: -111,
        },
      ],
      dropzones: [
        {
          name: "DropZone1",
          parent: "Simple",
          x: 510,
          y: -111,
        },
      ],
      masks: [
        {
          name: "Simple",
          type: "Simple",
          height: 222,
          width: 816,
          rotation: 0,
          fill: 0,
          x: 0,
          y: 183,
        },
      ],
      answer: [
        {
          token: "4c2",
          dropzone: "DropZone1",
        },
        {
          token: "-1c1",
          dropzone: "DropZone1",
        },
      ],
    },
  },
]
